/**
* 判断对象是否为空，空则返回true
* @param {Object} el 需要判断对象
*/
export const isEmpty = (obj) => {
  if (obj === undefined) return true
  for (let i in obj) return false
  return true
}

/**
* 对象转数组
* @param {Object} obj 对象
* @return {Array} 数组
*/
export const objToArr = (obj) => {
  var arr = []
  obj = obj || {}
  for (var k in obj) {
    arr.push(obj[k])
  }
  return arr
}

// 数组转换对象
export const arrToObj=(arr,k)=>{
  var obj = {}
  for(var i =0;i<arr.length;i++){
    obj[arr[i][k]]= arr[i]
  }
  return obj
}

export const extend = function(destination, source) { // 一个静态方法表示继承, 目标对象将拥有源对象的所有属性和方法
  for (var property in source) {
    destination[property] = source[property]   // 利用动态语言的特性, 通过赋值动态添加属性与方法
  }
  return destination   // 返回扩展后的对象
}

// 对象转url查询字符串
export const objectToQueryString = function (obj) {
  return Object.keys(obj).map(function (key) {
    return ''.concat(encodeURIComponent(key), '=').concat(encodeURIComponent(obj[key]))
  }).join('&')
}

export const groupBy = function ( array , f ) {
  let groups = {}
  array.forEach( function( o ) {
    let group = JSON.stringify( f(o) )
    groups[group] = groups[group] || []
    groups[group].push( o )
  })
  return Object.keys(groups).map( function( group ) {
    return groups[group]
  })
}
